import { SelectedPortForVehicleOutput } from './selected-port-for-vehicle-output.model';


export class DeviceSelectByVehicleDetailsIDOutputData implements IDeviceSelectByVehicleDetailsIDOutputData {
    /** The auto-generated id of the device master */
    device_id!: number;
    selected_port_specification!: SelectedPortForVehicleOutput[];

    constructor(data?: IDeviceSelectByVehicleDetailsIDOutputData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.device_id = _data["device_id"];
            if (Array.isArray(_data["selected_port_specification"])) {
                this.selected_port_specification = [] as any;
                for (let item of _data["selected_port_specification"])
                    this.selected_port_specification!.push(SelectedPortForVehicleOutput.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DeviceSelectByVehicleDetailsIDOutputData {
        data = typeof data === 'object' ? data : {};
        let result = new DeviceSelectByVehicleDetailsIDOutputData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["device_id"] = this.device_id;
        if (Array.isArray(this.selected_port_specification)) {
            data["selected_port_specification"] = [];
            for (let item of this.selected_port_specification)
                data["selected_port_specification"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IDeviceSelectByVehicleDetailsIDOutputData {
    /** The auto-generated id of the device master */
    device_id: number;
    selected_port_specification: SelectedPortForVehicleOutput[];
}

